import { useAppNotificationContext } from "./app-notification.context";

const AppNotificationHandler = () => {
  const { contextHolder } = useAppNotificationContext();

  return <>{contextHolder}</>;
};

export default AppNotificationHandler;
